import { useState, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useSiteContent } from "@/hooks/useSiteContent";

const darkPromoStyles: React.CSSProperties = {
  "--primary": "27 82% 50%",
  "--primary-foreground": "272 52% 10%",
} as any;

const PromoBanner = () => {
  const { t, content, loading } = useSiteContent();
  const location = useLocation();
  const [dismissed, setDismissed] = useState(false);

  const previewDesignId = Number(new URLSearchParams(location.search).get("preview_design") || "0");
  const configuredDesignId = Number(content.homepage_design || "1");
  const effectiveDesignId = previewDesignId > 0 ? previewDesignId : configuredDesignId;
  const isLightDesign = (effectiveDesignId >= 21 && effectiveDesignId <= 30) || effectiveDesignId === 51;

  const text = t("promo_banner_text", "");
  const link = t("promo_banner_link", "");
  const enabled = t("promo_banner_enabled", "");

  if (loading && !text) return null;
  if (!text || enabled === "false" || dismissed) return null;

  return (
    <div
      className="bg-primary text-primary-foreground relative overflow-hidden"
      style={{
        ...(isLightDesign ? darkPromoStyles : undefined),
        minHeight: "42px",
        containIntrinsicSize: "0 42px",
        contentVisibility: "visible",
      }}
    >
      {/* Subtle shimmer effect */}
      <div
        className="absolute inset-0 pointer-events-none opacity-[0.06]"
        style={{
          background: "linear-gradient(90deg, transparent 0%, white 50%, transparent 100%)",
          animation: "promo-shimmer 3s ease-in-out infinite",
        }}
      />
      <style>{`@keyframes promo-shimmer { 0%, 100% { transform: translateX(-100%); } 50% { transform: translateX(100%); } }`}</style>
      <div className="container mx-auto px-4 py-2.5 flex items-center justify-center gap-3 relative z-10">
        {link ? (
          <a
            href={link}
            className="text-[11px] sm:text-sm font-body tracking-[0.12em] text-center hover:underline underline-offset-2 transition-all"
          >
            {text}
          </a>
        ) : (
          <p className="text-[11px] sm:text-sm font-body tracking-[0.12em] text-center">{text}</p>
        )}
        <button
          onClick={() => setDismissed(true)}
          className="absolute right-3 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center rounded-full hover:bg-primary-foreground/15 transition-colors text-sm leading-none"
          aria-label="Close"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default PromoBanner;
